import { RedoFulfillmentLocationSchema } from "@redotech/redo-model/fulfillments/fulfillment-location";
import * as z from "zod";
import { null as zNull } from "zod";
export const getLocations = {
  name: "getLocations" as const,
  input: zNull(),
  output: z.object({ locations: z.array(RedoFulfillmentLocationSchema) }),
};
